import { Injectable, Pipe, PipeTransform, inject } from '@angular/core';
import { CompanyService } from 'app/modules/components/configuration/company/company.service.service';

/**
 * Currency symbol mapping
 * Maps currency codes to their corresponding symbols
 */
const CURRENCY_SYMBOLS: Record<string, string> = {
  'USD': '$',
  'HNL': 'L',
  'EUR': '€',
  'GBP': '£',
  'JPY': '¥',
  'CAD': 'C$',
  'MXN': 'Mex$',
  'GTQ': 'Q',
  'NIO': 'C$',
  'CRC': '₡',
  'PEN': 'S/',
  'COP': '$',
  'ARS': '$',
  'CLP': '$',
  'UYU': '$U',
  'BRL': 'R$',
};

@Pipe({
  name: 'companyCurrency',
  standalone: true
})
@Injectable({
  providedIn: 'root'
})
export class CompanyCurrencyPipe implements PipeTransform {
  private companyService = inject(CompanyService);

  transform(type: 'code' | 'symbol' = 'code', withParentheses = false): string {
    const company = this.companyService.getActiveCompany();

    if (!company?.currencyBase) return ''; // si no hay compañía o moneda, no muestra nada

    const code = company.currencyBase.code || '';

    // Get value based on type
    let value: string;
    if (type === 'symbol') {
      // Return symbol if available, fallback to code
      value = CURRENCY_SYMBOLS[code] || code;
    } else {
      // Return code
      value = code;
    }

    if (withParentheses && value) {
      return `(${value})`;
    }

    return value;
  }
}
